import React from 'react';
export function Guarantee() {
  return <section aria-labelledby="guarantee-title" className="border-t-2 border-ink bg-ink text-cream" data-id="element-51" data-mp="1qalq4w8vplqd">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-6 px-5 py-12 md:flex-row md:gap-10 lg:py-20" data-id="element-52" data-mp="1o33xor06cami">
        <div className="flex h-28 w-28 shrink-0 flex-col items-center justify-center rounded-full border-4 border-dashed border-rust text-center sm:h-40 sm:w-40" data-id="element-53" data-mp="221bw73cuzjzs">
          <span className="font-display text-5xl font-black leading-none text-rust sm:text-6xl" data-id="element-54" data-mp="19firupbwzxaw">7</span>
          <span className="mt-1 font-display text-sm font-extrabold uppercase tracking-widest" data-id="element-55" data-mp="14gz2eey443ds">days</span>
        </div>
        <div className="text-center md:text-left" data-id="element-56" data-mp="1j5vbmfbwnmfz">
          <h2 id="guarantee-title" className="font-display text-[1.75rem] font-black leading-tight sm:text-4xl" data-id="element-57" data-mp="1edkaxa9cbwmd">
            7-day satisfaction guarantee
          </h2>
          <p className="mt-4 text-lg font-medium" data-id="element-58" data-mp="lp6bqr6imu98">7 days to see it for yourself.</p>
          <p className="mt-3 leading-relaxed text-kraft-light" data-id="element-59" data-mp="ln290ckcs1aj">
            If it’s not for you, I’ll refund every cent. No questions asked, no fine print. Just write to me and that’s
            it. I offer this because I trust the method. Simple.
          </p>
        </div>
      </div>
    </section>;
}